import React, { useEffect, useState } from "react";
import {
  HiOutlineArrowNarrowLeft,
  HiOutlineArrowNarrowRight,
} from "react-icons/hi";
const CustomPagination = ({ currentPage, totalPages, onPageChange }) => {
  const [inputValue, setInputValue] = useState(currentPage);

  const handleInputChange = (e) => {
    e.preventDefault();
    let targetValue = e.target.value.trim(); // Remove leading and trailing spaces
    if (targetValue === "") {
      setInputValue((prev) => null);
      return;
    }
    targetValue = parseInt(targetValue);
    if (targetValue === 0) {
      setInputValue((prev) => 1);
    } else if (targetValue > totalPages) {
      setInputValue((prev) => totalPages);
    } else {
      setInputValue((prev) => targetValue);
    }
  };

  const onKeyDown = (event) => {
    if (event.key === "Enter") {
      if (event.target.value.trim() === "" || inputValue === null) {
        alert("Invalid page number");
      } else {
        onPageChange(inputValue);
      }
      return;
    }
  };

  // Update inputValue when the currentPage prop changes
  useEffect(() => {
    setInputValue(currentPage);
  }, [currentPage]);

  return (
    <div className="d-flex justify-content-center  align-items-center">
      <div className="flex-grow-1 ">
        <div className="position-relative d-grid float-end">
          <div className="d-flex">
            {currentPage > 1 && (
              <button
                className="btn btn-primary align-middle align-content-start"
                onClick={() => {
                  setInputValue((prev) => prev - 1);
                  onPageChange(inputValue - 1);
                }}
              >
                <HiOutlineArrowNarrowLeft className="fs-4 me-2" />
                Previous Page
              </button>
            )}

            {currentPage < totalPages && (
              <button
                className="btn btn-primary ms-2 d-flex align-items-center"
                onClick={() => {
                  setInputValue((prev) => prev + 1);
                  onPageChange(inputValue + 1);
                }}
              >
                Next Page <HiOutlineArrowNarrowRight className="fs-4 ms-2" />
              </button>
            )}
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        {totalPages > 0 && (
          <div className="position-relative d-grid float-end">
            <div className="d-flex align-items-center">
              <span className="me-2">Page</span>
              <input
                type="number"
                value={inputValue}
                onChange={(e) => handleInputChange(e)}
                onKeyUp={(e) => onKeyDown(e)}
                className="form-control text-center"
                style={{ width: "60px" }}
                required={true}
              />
              <span className="ms-2">of {totalPages}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default CustomPagination;
